<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel && (DataType==2 || DataType==8)"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'880px','max-height':'800px','min-height':'350px'}">
        
        <Form ref="formDynamic" :model="formDynamic" :rules="ruleCustom" :label-width="80" >

             <div v-for="(item, index) in formDynamic.items" :key="index" >

                <div style="display:flex;justify-content:flex-start;flex-wrap:wrap" v-show="item.status">

                    <!--key5:'wordId',  key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',ke6:'pageId_wordId' -->
               
                    <FormItem   v-if="languageKey.key3"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key3}`) + item.index"  :prop="'items.' + index + '.'+languageKey.key3"  style="width:420px"
                         :rules="{required: item.status===1?true:false, message: languageKey.key3 + item.index +' can not be empty', trigger: 'change'}">
                        
                         <!-- {{ 'type:'+type }} -->
                    

                        <div v-if="isGener && !item.hasWord" class="ivu-input">{{ item.LanguageKey }} {{ local=='zh-CN'?item['Name-CN']:item['Name-EN'] }}</div>

                        <template v-else>
                            <SearchSelectPage  :refName="'select'+index" listName="dealersList"  :showPage="true" :ref="'select'+index" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,item.index)"></SearchSelectPage>
                        </template>

                    </FormItem>

      
                    <FormItem   v-if="languageKey.key2"  :label="'Code' + item.index"  :prop="'items.' + index + '.'+languageKey.key2"  style="width:300px"
                         :rules="{required: item.status===1?true:false, message: languageKey.key2 + item.index +' can not be empty', trigger: 'blur'}">
                        <Input type="text" v-model="item[languageKey.key2]" :placeholder="$t('inputPlaceholder')"></Input>
                          
                    </FormItem>
                    
                    
                    <FormItem  v-if="item.status && !isGener"  style="width:100px" class="delButton">
                       <Button type="error" :disabled="enumDelDisabled" @click="handleRemove(index)">{{$t("delete")}}</Button>
                    </FormItem>
                </div>
                 

             </div>

            
             <FormItem  v-if="!isGener">
                <Row>
                    <Col span="12">
                        <Button type="dashed" long @click="handleAdd" icon="md-add">{{$t("add")}}</Button>
                    </Col>
                </Row>
            </FormItem>
            
            <FormItem v-if="isGener">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>

            <FormItem v-else>
                <Button type="primary" @click="handleSubmit('formDynamic')">{{$t("save")}}</Button>
                <!-- <Button @click="handleReset('formDynamic')" style="margin-left: 8px">{{$t("reset")}}</Button> -->
                <Button @click="cancel" style="margin-left: 8px">{{$t("cancel")}}</Button>
            </FormItem>

        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
// import SearchSelectPage from '@/views/common/selectListPage.vue';  //20220415
import SearchSelectPage from '@/views/common/selectListRecycle.vue';  //20220415

import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            DataType:String,
            // languageKey:Object,
            // initdata:Object,
   
            pageId:[Number, String],
            isGener:{
                type:Boolean,
                default:false
            }
        },
        name: "Model6",
       
        data() {
            return {   
                disabled: false,//禁用确定按钮
                pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表
                title: '设置',//弹框标题
                formData: {//表单数据
                   
                }, 
                index: 1,
                enumDelDisabled:true,
                formDynamic: {
                    items: [
                        {'Name-CN':'',"Name-EN":"",Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}
                    ],
                },
                descText:'',
                wordList:[],
                wordListLoading:false,
                initdata:{'Name-CN':'',"Name-EN":"",Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1},
                languageKey:{key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',key5:'wordId',key6:'pageId_wordCode'},
               
            }
        },
        components:{
            SearchSelectPage
        },
        computed:{
            ...mapState(['local','selectId','wordListAll','wordListByPageId','pageIdStore']),
             ruleCustom(){
                 return {//验证
                }
             } 

        },
        created(){
            this.pageID = this.pageId || this.pageIdStore || ''
           
        },
        methods: {
            setSelectValPage(selItem,index){
                if(selItem){
                   (this.formDynamic.items[index-1])[this.languageKey.key5] = selItem.id+'';
                   (this.formDynamic.items[index-1])[this.languageKey.key3] = selItem.wordCode+'' || '';
                   (this.formDynamic.items[index-1])[this.languageKey.key6] = this.pageID+'_'+selItem.wordCode+''||'';
                   (this.formDynamic.items[index-1])[this.languageKey.key1] = selItem.simpleChinese+''|| '';
                   (this.formDynamic.items[index-1])[this.languageKey.key4] = selItem.englishText+''||''
                }else{
                    this.clearSelectVal(index)
                }
            },
           
            setDefaultSelectPage(){
                console.log(6666666)
                for(let i=0;i<this.formDynamic.items.length;i++){
                    let param = {
                        id:this.formDynamic.items[i].wordId,
                        wordCode:this.formDynamic.items[i].LanguageKey
                    }

                    this.$nextTick(()=>{
                        if(this.$refs['select'+i] && this.$refs['select'+i][0]){

                            this.$refs['select'+i][0].setDefVal(param)
                        }
                    })

                }
            },
            clearSelectVal(index){
                (this.formDynamic.items[index-1])[this.languageKey.key5] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key3] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key6] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key1] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key4] = ''

            },
            handleSubmit (name) {
                // console.log('this.formDynamic.items',this.formDynamic.items)
                if(this.isGener){
                    return
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        const arr1 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1.LanguageKey)
                        const arr2 = new Set(arr1)
                        if(arr2.size != arr1.length){
                            this.$Message.error(this.$t('BasicProduct.funcBox.titleName.LanguageKey')+'重复');
                            return
                        }
                        

                        const arr3 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1.Code)
                        const arr4 = new Set(arr3)
                        if(arr3.length > arr4.size){
                            this.$Message.error('Code 重复');
                            return
                        }


                        // const arr5 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1[this.languageKey.key5])
                        // const arr6 = new Set(arr5)
                        // if(arr5.length > arr6.size){
                        //     this.$Message.error('词条 重复');
                        //     return
                        // }



                        if(this.DataType =='8'){
                            let flag = 0
                            arr3.map(item=>{
                                if(!/^0[xX][0-9a-fA-F]+/.test(item)){
                                    flag = 1
                                }
                            })

                            // console.log('arr3',arr3)
                            // console.log('this.formDynamic.items',this.formDynamic.items)
                            if(flag){
                                this.$Message.error(this.$t('ruleCustom.16'));
                                return
                            }
                        }
                        //遍历数据，如果是新增，LanguageKey重复则提示
                        if(this.type==1){
                            let arr = this.editFormData.allArr
                            for(let i = 0;i< arr.length;i++){
                                if((arr[i])[0].LanguageKey==this.formDynamic.items[0].LanguageKey && (arr[i])[0].status){
                                   this.$Message.error('LanguageKey 与已存在列表重复')
                                   return
                                }
                            }
                        }


                        let emitArr = this.formDynamic.items.filter((item)=>{
                           return  item.status==1
                        }).map(item=>{
                            delete item.status
                            delete item.index
                            if(!item[this.languageKey.key6]){
                                item[this.languageKey.key6] = this.pageID+'_'+item[this.languageKey.key3]+''
                            }
                            return item
                        })
                        
                        this.fn(emitArr,this.descText)
               
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
                // this.formDynamic.items = this.formDynamic.items.map(item=>{
                //     item[this.languageKey.key5] = ''
                //     item[this.languageKey.key3] = ''
                //     item[this.languageKey.key6] = ''
                //     item[this.languageKey.key1] = ''
                //     item[this.languageKey.key4] = ''
                //     item[this.languageKey.key2] = ''

                //     return item
                // })

            },
            handleAdd () {
                this.index++;
                let obj = common.deepClone({...this.initdata,index: this.index})
                this.formDynamic.items.push(obj)
                let arr = this.formDynamic.items.filter(item=>item.status)
                if(arr.length>1) this.enumDelDisabled = false

                let len = this.formDynamic.items.length-1

                this.$nextTick(()=>{
                    this.$refs['select'+len][0].getData()
                })
            },
            handleRemove (index) {
                this.formDynamic.items[index].status = 0;
                this.$nextTick(()=>{
                    this.$refs['select'+index][0].clearVal()
                })
                let arr = this.formDynamic.items.filter(item=>item.status)
                if(arr.length<2) this.enumDelDisabled = true
                
                
                this.$forceUpdate()
            },
            async openOrClose(value) {
                if(value === true) {
           
                    // console.log('this.editFormData.IndentyName',this.editFormData.IndentyName)
 
                    if(this.type==1){
                        this.index = 1
                        this.formDynamic.items = common.deepClone( [{...this.initdata}])
                        this.enumDelDisabled = true
                        if(this.$refs['select0'][0]){

                            this.$refs['select0'][0].getData()
                        }
                    }else{
                        
                        this.formDynamic.items = common.deepClone([...this.editFormData.IndentyName])
                         
                            //    console.log('this.formDynamic.items',this.formDynamic.items)
                            //     console.log('this.editFormData.IndentyName',this.editFormData.IndentyName)

                        let flag = 1
                        this.formDynamic.items.map((item)=>{
                            if(!item.LanguageKey){
                                flag=0
                            }
                        })
                        if(flag==0){
                            for(let i=0;i<this.editFormData.IndentyName.length;i++){
                                for(let j=0;j<this.formDynamic.items.length;j++){
                                    if(this.editFormData.IndentyName[i].pageId_wordCode==this.formDynamic.items[j].pageId_wordCode && !this.formDynamic.items[j].LanguageKey){
                                        this.formDynamic.items[j].LanguageKey = this.editFormData.IndentyName[i].LanguageKey
                                        this.formDynamic.items[j].Code = this.editFormData.IndentyName[i].Code
                                    }
                                }
                            }
                        }

                        this.setDefaultSelectPage()
                        
                        this.index = this.editFormData.IndentyName.length

                        if(this.formDynamic.items.length>1) this.enumDelDisabled = false
                    }

                }
            },
            cancel() {//对话框关闭
                this.resetForm()
                this.$emit('update:showSetModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formDynamic.resetFields();//重置表单
                for(let i=0;i<this.formDynamic.items.length;i++){
                    // console.log("this.$refs['select'+i]",this.$refs['select'+i])
                    if(this.$refs['select'+i]){
                        this.$refs['select'+i][0].clearVal()
                    }
                }
                this.formDynamic.items = common.deepClone( [{...this.initdata}])
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
        .ivu-select-dropdown {
            max-width: 250px;
        }
    }
     .ivu-modal-body {
        max-height: 800px;
         // overflow-y: scroll;
        overflow: auto;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}
.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
}
}
</style>

